module.exports = __webpack_public_path__ + "static/media/tower2.3cb9f808.jpg";